// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function assertUnreachable(_) {
    throw new Error("Didn't expect to get here");
}
//# sourceMappingURL=assertUnreachable.js.map